import { render, staticRenderFns } from "./employeesRoleDialogyh.vue?vue&type=template&id=132e36a7&"
import script from "./employeesRoleDialogyh.vue?vue&type=script&lang=js&"
export * from "./employeesRoleDialogyh.vue?vue&type=script&lang=js&"
import style0 from "./employeesRoleDialogyh.vue?vue&type=style&index=0&id=132e36a7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports